module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-sample-03-stack-01.81a40d8b.jpg";